import { SubmissionFileTracker } from '@/components/SubmissionFileTracker';

export default function SubmissionTracker() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Submission Tracker</h1>
        <p className="text-gray-600">Track customer submissions and their associated files</p>
      </div>
      
      <SubmissionFileTracker />
    </div>
  );
}
